import ExpansionQuestDTO from "../../models/quest/ExpansionQuestDTO";
import axios from "axios";
import BackendClient from "../../BackendClient";

export function getQuestForEdit(client: BackendClient, questId: number): Promise<ExpansionQuestDTO> {
    const headers = {
      'Authorization': `${client.getAuthEntity()} ${client.getAuthToken()}`,
    };

    return new Promise<ExpansionQuestDTO>((resolve, reject) => {
      axios.get(`${client.getBackendUrl()}${BackendClient.GetQuestForEdit}`, {headers: headers, params: {id: questId}})
        .then((response) => resolve(response.data))
        .catch((reason) => {
          console.log(`Exception when getting quest: ${JSON.stringify(reason)}`)
          reject(reason);
        });
    });
  }